import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, DatePicker, ConfigProvider, Space, Select } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Btns, FormContainer } from "./styled";
import dayjs from 'dayjs';


export function ModalEditarAlvara({ isOpen, onClose, id, listTipo, listSituacao, fetchData }) {
    const [loadings, setLoadings] = useState(false);
    const [isIdCliente, setIsItCliente] = useState("");
    const dateFormat = 'YYYY-MM-DD';
    const [atualDate, setAtualDate] = useState(dayjs().format(dateFormat));
    const [tipoList, setTipoList] = useState([]);
    const [situacaoList, setSituacaoList] = useState([]);
    const [showDatePicker, setShowDatePicker] = useState(false);

    const [newData, setNewData] = useState({
        id: "",
        cliente: "",
        cnpj: "",
        nome: "",
        tipoId: "",
        tipoNome: "",
        situacaoId: "",
        situacaoNome: "",
        dataEmissao: "",
        dataExpiracao: ""
    })

    useEffect(() => {
        setAtualDate(dayjs().format(dateFormat));
        consultarData(id);
        setIsItCliente(id);
        setTipoList(listTipo);
        setSituacaoList(listSituacao);
    }, []);

    const consultarData = async (id) => {
        const url = "/portal/rest/contador/alvara/consultar";
        const param = {
            id: id
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });

            setNewData(prevState => ({
                ...prevState,
                id: response.data.id,
                cliente: response.data.cliente.id,
                cnpj: response.data.cliente.cnpj,
                nome: response.data.cliente.nome,
                dataEmissao: response.data.dataEmissao,
                dataExpiracao: response.data.dataExpiracao,
                situacaoId: response.data.situacao.id
            }))

        } catch {
            toast.error("Erro ao buscar os dados.");
        }
    }

    const postData = async () => {
        const url = "/portal/rest/contador/alvara/atualizar";
        const param = {
            dataEmissao: newData.dataEmissao,
            dataExpiracao: newData.dataExpiracao,
            id: newData.id,
            cliente: {
                id: newData.cliente
            },
            situacao: {
                id: newData.situacaoId,
                nome: newData.situacaoNome
            },
            tipo: {
                id: newData.tipoId,
                nome: newData.tipoNome
            }

        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            onClose();
            fetchData();
        } catch {
            toast.error("não foi possível salvar os dados.");
        }
    }

    const handleCancel = () => {
        onClose();
    };

    const changeId = (e) => {
        setNewData({
            ...newData,
            id: e.target.value
        })
    }

    const changeCliente = (e) => {
        setNewData({
            ...newData,
            cliente: e.target.value
        })
    }

    const changeCnpj = (e) => {
        setNewData({
            ...newData,
            cnpj: e.target.value
        })
    }

    const changeNome = (e) => {
        setNewData({
            ...newData,
            nome: e.target.value
        })
    }

    const clearForm = () => {
        setNewData({
            codigo: "",
            id: "",
            senha: "",
            site: "",
            tipo: ""
        });
    };

    const onChangeSituacao = (value, nome) => {
        setNewData({
            ...newData,
            situacaoId: value,
            situacaoNome: nome.label
        })
        setShowDatePicker(value === 'A');
    };

    const onChangeTipo = (value, nome) => {
        setNewData({
            ...newData,
            tipoId: value,
            tipoNome: nome.label
        })
    };

    return (
        <Form.Item>
            <Modal
                title="Tratamento de Alvarás e Licenças"
                open={isOpen}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Btns>
                            <Button key="cancel" onClick={handleCancel}>
                                Cancelar
                            </Button>
                            <Button className="btn" loading={loadings} onClick={postData}>
                                <SaveOutlined /> Salvar
                            </Button>
                        </Btns>
                    </>
                ]}
            >
                <FormContainer>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="id"
                        >
                            <label className="label" tmlFor="">Id:</label>
                            <Input placeholder={newData.id || "Id"} onChange={changeId} value={newData.id} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="cnpj"
                        >
                            <label className="label" htmlFor="">CNPJ:</label>
                            <Input placeholder={newData.cnpj || "cnpj"} onChange={changeCnpj} value={newData.cnpj} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="Tipo"
                            value={newData.tipo}
                        >
                            <label className="label" htmlFor="">Tipo:</label>
                            <Select
                                showSearch
                                placeholder="Selecione o tipo"
                                style={{ maxWidth: "180px" }}
                                onChange={onChangeTipo}
                                filterOption={(input, option) =>
                                    option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                }
                            >
                                {tipoList.map(item => (
                                    <Select.Option key={item.id} value={item.id} label={item.nome} >
                                        {item.nome}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {showDatePicker && (
                            <Form.Item
                                className="form-item"
                                label="Data Emissão:"
                                name="dataEm"
                            >
                                <Space direction="vertical">
                                <ConfigProvider locale={ptBR}>
                                <DatePicker
                                        className="date-picker"
                                        value={newData.dataEmissao ? dayjs(newData.dataEmissao, dateFormat) : null}
                                        format={dateFormat}
                                        onChange={(date, dateString) => {
                                            setNewData(prevState => ({
                                                ...prevState,
                                                dataEmissao: dateString
                                            }));
                                        }}
                                    />
                                </ConfigProvider>
                                    
                                </Space>
                            </Form.Item>
                        )}
                    </div>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="cliente"
                        >
                            <label className="label" htmlFor="">Cliente:</label>
                            <Input placeholder={newData.cliente || "cliente"} onChange={changeCliente} value={newData.cliente} />
                        </Form.Item>

                        <Form.Item
                            className="form-item"
                            name="nome"
                            value={newData.nome}
                        >
                            <label className="label" htmlFor="">Nome:</label>
                            <Input placeholder={newData.nome || "nome"} onChange={changeNome} value={newData.nome} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="situação"
                            value={newData.situação}
                        >
                            <label className="label" htmlFor="">Situação:</label>
                            <Select
                                showSearch
                                placeholder="Selecione um tipo de situação"
                                onChange={onChangeSituacao}
                                // onSearch={onSearchSituacao}
                                filterOption={(input, option) =>
                                    option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                }
                            >
                                {situacaoList.map(item => (
                                    <Select.Option key={item.id} value={item.id} label={item.nome}>
                                        {item.nome}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {showDatePicker && (
                            <Form.Item
                                className="form-item"
                                label="Data Expiração:"
                                name="dataExp"
                            >
                                <Space direction="vertical">
                                <ConfigProvider locale={ptBR}>
                                <DatePicker
                                        className="date-picker"
                                        value={newData.dataExpiracao ? dayjs(newData.dataExpiracao, dateFormat) : null}
                                        format={dateFormat}
                                        onChange={(date, dateString) => {
                                            setNewData(prevState => ({
                                                ...prevState,
                                                dataExpiracao: dateString
                                            }));
                                        }}
                                    />
                                </ConfigProvider>
                                    
                                </Space>
                            </Form.Item>
                        )}
                    </div>
                </FormContainer>
            </Modal>
        </Form.Item>
    );
};

export default ModalEditarAlvara;